// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Content_Transactions(
  $where_transactions: vaxiom_transactions_bool_exp!
  $where_payments: vaxiom_payments_bool_exp!
  $patient_id: numeric!
) {
  transactions: vaxiom_transactions(where: $where_transactions) {
    id
    dtype
    sys_created
    sys_created_by
    effective_date
    amount
    notes
    receivable_id
    created_by_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
    applied_payment {
      id
      applied_type
      payment {
        id
        payment_type
        check_number
        last_four_digits
        transaction_id
        payer_name
        type_info
        account {
          id
          account_type
          person_payment_account {
            id
            payer_person {
              id
              first_name
              last_name
            }
          }
          insurance_payment_account {
            id
            insurance_company {
              id
              carrier_name
            }
          }
        }
      }
    }
    receivable {
      payment_account {
        id
        account_type
        person_payment_account {
          id
          payer_person {
            id
            first_name
            last_name
          }
        }
        insurance_payment_account {
          id
          insurance_company {
            id
            carrier_name
          }
        }
      }
    }
  }
  notes: vaxiom_notes(
    where: {
      target_id: { _eq: $patient_id }
      target_type: { _eq: "Patient.Ledger" }
    }
  ) {
    id
    _id
    notes: note
    target_type
    sys_created
    author
    author_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
  }
  payments: vaxiom_payments(where: $where_payments) {
    id
    payment_type
    amount
    check_number
    last_four_digits
    transaction_id
    payer_name
    type_info
    sys_created
    notes
    payment_account: account {
      id
      account_type
      person_payment_account {
        id
        payer_person {
          id
          first_name
          last_name
        }
      }
      insurance_payment_account {
        id
        insurance_company {
          id
          carrier_name
        }
      }
    }
  }
}

`